import { find, get, keyBy, mapValues, template, templateSettings } from "lodash";

export const getPageContent = (state, name) => {
  const {
    survey,
    survey: { branch, pages },
    i18n: { locale }
  } = state;

  // Find page content based on these properties
  const page = find(pages, { name, branch, locale });
  const content = get(page, "content", "");

  // TODO: add dynamic environment variables to the ones defined
  // const BRANCH = branch;
  // const LOCALE = locale;
  const environment = mapValues(keyBy(get(survey, 'environment', []), 'name'), 'value');

  try {
    templateSettings.interpolate = /{{([\s\S]+?)}}/g;
    const compiled = template(content);
    return compiled(environment);
  } catch (error) {
    console.log(error);
  }
};

export default getPageContent;
